import { getAsync } from "./http-client";

const ShopApi = {
    getShopServiceInfo: async (shopIdx) => {
        return await getAsync(`/shop/getFreeTrialInfo/${shopIdx}`);
    },
    getPremiumAmountWithVat: async (params) => {
        return await getAsync(`/payment/getPremiumAmountWithVat`,params);
    },
};
export default ShopApi;
